// extracted by mini-css-extract-plugin
export default {"self":"MassList-module--self--odu-A","spin":"MassList-module--spin--GyyYq"};